import React, { useState } from 'react';
import './style.css';
import img from './Team Images/Deshna Sharma1.jpeg';
import img1 from './Team Images/Bhanu1.jpeg';
import img2 from './Team Images/Sanskar Kumar.jpg';
import img3 from './Team Images/Ananya Kapil1.jpeg';
import img4 from './Team Images/Ananya Tiwari.jpeg';
import img5 from './Team Images/Sanskriti.jpeg';
import img6 from './Team Images/Aakriti Sharma.jpg';
import img7 from './Team Images/Akash.jpeg';
import img8 from './Team Images/Kinjalk Nagpal1.jpeg';
import img9 from './Team Images/Priyanshu.jpg';
import img10 from './Team Images/Aryanshi Rana.webp';
import img11 from './Team Images/Abhinav Kaintura.jpg';
import img12 from './Team Images/Rohan.jpg';
import img13 from './Team Images/Uttkarsh Sharma2.jpg';
import img14 from './Team Images/Ashma.jpg';
import img15 from './Team Images/Vidhi Thapa.jpg';
import img16 from './Team Images/Madhav Nair.jpg';
import img17 from './Team Images/Shrejal Kirsali.png';
import img18 from './Team Images/YASH KHANDURI.jpg';
import img19 from './Team Images/Akshit.jpg';
import { FaLinkedin } from "react-icons/fa";

const Modal = ({ onClose, member }) => {
    const handleOutsideClick = (e) => {
        if (e.target.classList.contains('modal-overlay')) {
            onClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOutsideClick}>
            <div className="modal-content">
                <span className="close" onClick={onClose}>&times;</span>
                <h3 className='pop-name'>{member.name}</h3>
                <p className='pop-role'>{member.role}</p>
                <ul>
                    {member.desc.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                    ))}
                </ul>
                <p className='social'>Connect with me on:<a href={member.linkedin} target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                </a></p>

            </div>
        </div>
    );
};


const TeamSection = ({ teamMembers, faculty }) => {
    const [selectedMember, setSelectedMember] = useState(null);

    const openModal = (member) => {
        setSelectedMember(member);
    };

    const closeModal = () => {
        setSelectedMember(null);
    };

    return (
        <div className="container4">
            <h1>OUR TEAM</h1>
            <div className="home">
                {faculty.map((member, index) => (
                    <div key={index} className="profile" onClick={() => openModal(member)}>
                        <div className="img">
                            <img src={member.image} alt={member.name} />
                        </div>
                        <div className="caption">
                            <h3>{member.name}</h3>
                            <p className='role'>{member.role}</p>
                        </div>
                    </div>
                ))}
            </div>
            <div className="home">
                {teamMembers.map((member, index) => (
                    <div key={index} className="profile" onClick={() => openModal(member)}>
                        <div className="img">
                            <img src={member.image} alt={member.name} />
                        </div>
                        <div className="caption">
                            <h3>{member.name}</h3>
                            <p className='role'>{member.role}</p>
                        </div>
                    </div>
                ))}
            </div>
            {selectedMember && <Modal onClose={closeModal} member={selectedMember} />}
        </div>
    );
};



const App = () => {

    const faculty = [
        {
            name: 'ABCD',
            role: 'Faculty Coordinator',
            image: img,
            linkedin: 'https://www.linkedin.com/in/abhinav-giri-644707256/',
            desc: [
                'Lorem ipsum dolor sit amet, consectetur adipisicing elit',
                'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum eum voluptate, aperiam blanditiis minima enim dolorum facilis voluptatem possimus dolor odio iure deleniti saepe corporis doloribus explicabo laboriosam, deserunt et.',
            ],
        },

        {
            name: 'ASDF',
            role: 'Faculty Coordinator',
            image: img1,
            linkedin: 'https://www.linkedin.com/in/abhinav-giri-644707256/',
            desc: [
                'Pursuing Clinical Research and aspiring to work in the field of Pharmacology and Pharmacovigilance.',
                'Serving as the General Secretary in an NGO.',
                'Published abstracts in research conferences and currently working on a research project.',
            ],
        },
    ];
    const teamMembers = [
        {
            name: 'Deshna Sharma',
            role: 'President',
            image: img,
            linkedin: 'https://www.linkedin.com/in/deshna-sharma-3b8834236?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            desc: [
                'Pursuing Clinical Research and aspiring to work in the field of Pharmacology and Pharmacovigilance.',
                'Serving as the General Secretary in an NGO.',
                'Published abstracts in research conferences and currently working on a research project.',
                'Ozone Student Society works towards the growth and engagement of the students of health sciences and technology. It aims to be a bridge between the students of other cohorts and the students of health sciences. Working towards the better health and better environment in and around the campus. '
            ],
        },
        {
            name: 'Bhanu Pratap Singh',
            role: 'Vice-President',
            image: img1,
            linkedin: 'https://www.linkedin.com/in/bhanu-pratap-singh-a81026259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            desc: [
                'I am currently enrolled in the pursuit of a B.Sc. in Microbiology, where my academic focus involves a comprehensive exploration of microbial science. ',
                'As a passionate individual, I am consistently eager to learn and expand my knowledge within the field, driven by a curiosity that fuels my academic journey.',
                'Additionally, I consider myself a creative problem-solver, unafraid to think outside the box and approach challenges with innovative solutions. This mindset allows me to navigate complex issues with a fresh perspective',
                'Ozone is a society that helps the students  in gaining professional knowledge about our healthcare sector. We aim to provide hands-on experience to members and students willing to join us."It will bost  professional skills as well.'
            ],

        },
        {
            name: 'Sanskar Kumar',
            role: 'Society Officer',
            image: img2,
            linkedin: 'https://www.linkedin.com/in/sanskar-kumar-a1a467232?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            desc: [
                'I possess a volatile personality that propels me to actively pursue and seize opportunities in various aspects of my life.',
                'Dissatisfaction with mediocrity serves as a constant motivator, compelling me to consistently strive for improvement and excellence.',
                'I am not content with complacency and am continuously exploring methods to enhance myself and achieve higher standards.',
                'Fostering innovation and environmental stewardship among students. Empowering future leaders to drive positive change through sustainable practices and collaborative initiatives.'
            ],

        },
        {
            name: 'Ananya Kapil',
            role: 'Secretary',
            image: img3,
            linkedin: 'https://www.linkedin.com/in/ananya-kapil-7a82932a0?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
            desc: [
                'A dedicated and passionate young woman, excelling academically with impressive grades.',
                'Actively participating in various extracurricular activities, I bring my determination to both my studies, earning impressive grades, and diverse interests.',
                'My commitment to excellence is evident in my academic achievements and my active engagement in a variety of pursuits.',
                'Ozone Student Society, dedicated to health science and technology, fervently strives to advance human well-being. Through a fusion of knowledge and innovation, this society passionately contributes to the intersection of healthcare and technology for the betterment of society.'
            ],

        }, {
            name: 'Ananya Tiwari',
            role: 'Treasurer',
            image: img4,
            linkedin: 'https://www.linkedin.com/in/ananya-tiwari-852583256?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
            desc: [
                'Currently in my 2nd year pursuing Integrated Clinical Research.',
                'Proudly serving as the treasurer, I oversee and report on all club committees and programs to the Executive Board.',
                'Excited about the opportunity and looking forward to collaborating with all of you!',
                'Ozone Student Society is a group of students with shared interests, goals, or activities. Provide a platform for students to connect, collaborate, and engage in extracurricular pursuits beyond academic studies.'
            ],

        },
        {
            name: 'Yash Khanduri',
            role: 'Advisor',
            image: img18,
            linkedin: 'https://www.linkedin.com/in/yash-k-973182205?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
            desc: [
                'Currently pursuing BTech in Biotechnology, with roots deeply embedded in the scenic mountains of Rudraprayag.',
                'My interests encompass leadership skills, management, marketing tactics, as well as a passion for photography and cinematography.',
                'Through my academic journey and diverse interests, I aspire to blend the scientific and creative realms for a holistic approach to personal and professional growth.',
                'For me ozone is  whole soul crux of our School of Health Sciences and Technology'
            ],
        },
        {
            name: 'Sanskriti Dwivedi',
            role: 'Editorial Head',
            image: img5,
            linkedin: 'https://www.linkedin.com/in/sanskriti-dwivedi-0b71b02a0/',
            desc: [
                'Hard work, Harmony and Happiness are my ways to ace life!',
                'An aspiring microbiologist and a changemaker, I wish to take on a journey towards scientific discovery, contributing to advancements that, at their core, seek to elevate human health.',
                'I am a determined believer who welcomes challenges, recognizing each obstacle as a step towards success and personal growth.',
                'Ozone to me is a wish come true! A small initiative taken by a group of friends unaware of how prominent it would become in the future, Ozone is an inspiration for those who wish to make a change and pave the way for a healthier future.'
            ],
        },
        {
            name: 'Aakriti Sharma',
            role: 'Photography Head',
            image: img6,
            linkedin: 'https://www.linkedin.com/in/aakriti-sharma-116a70263',
            desc: [
                "I'm currently pursuing BSc Food Nutrition and Dietetics at UPES, diving into the details with genuine interest.",
                "I'm part of Ozone, where I contribute my skills and dedication achieve common goals.",
                'I also have a deep passion for photography and thoroughly enjoy capturing moments through the lens, immersing myself in the art and craft of photography',
                'Ozone is a health sciences student society that gives us the platform to collaborate and learn the new advancements in the field of health care.'
            ],
        },
        {
            name: 'Akash Ghansela',
            role: 'CSR Head',
            image: img7,
            linkedin: 'https://www.linkedin.com/me?trk=p_mwlite_feed_updates-secondary_nav',
            desc: [
                'My name is Akash Ghansela , I am in B pharm second year',
                'Ozone is the health and safety society of upes and only society for students of school of Heath science and technology. Ozone provide opportunity to learn and implement impactfull works towards environment and safety',
            ],

        },
        {
            name: 'Kinjalk Nagpal',
            role: 'PR And Sponsorship Head',
            image: img8,
            linkedin: 'https://www.linkedin.com/in/kinjalk-nagpal?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
            desc: [
                'Passionate about learning and diverse activities, I am recognized in college for academic dedication and active extracurricular involvement.',
                "Balancing studies and community contributions, I've excelled, fostering personal growth and meaningful connections.",
                "As an organizer, my highlights include coordinating events like a treasure hunt and food stalls alongwith contributing to RRR since 2022.",
                "The Ozone Student Society at UPES Dehradun is a recent addition to the college's vibrant community. Despite its new establishment, the society has already made significant strides in fostering a dynamic academic environment. Noteworthy events such as World Microbiology Day and Pharmacist Day showcase the society's commitment to exploring and celebrating advancements in health sciences. A notable collaboration with the Horizon Society resulted in the successful execution of 'Bhawishyam,' an initiative where school students were introduced to college labs and provided valuable insights into health sciences courses. Rooted in the Department of Health Sciences, Ozone Society emerges as a promising platform bridging the gap between academia and practical knowledge, setting the stage for future endeavours and contributions to the college community.I know I have exceeded the limit but I have so much to say about this society that I could not stop myself. The experiences I already gained being a part of this society is so precious that I would not want to loose a single chance to help it reach the pinnacle."
            ],
        },
        {
            name: 'Priyanshu Turup',
            role: 'Event Management Head',
            image: img9,
            linkedin: 'https://www.linkedin.com/in/priyanshu-turup-789485264/',
            desc: [
                'I am currently a student pursuing B.Sc. Microbiology at UPES. I actively participate in OZONE, a society known for its hardworking members.',
                'Being an enthusiastic individual, I am always eager to learn and discover new things.',
                'One of my guiding principles is the importance of working smart, recognizing its role in achieving goals efficiently.',
                "OZONE is first health science society of UPES, which looks at it's student achievements and provide them a platform to represent themselves."
            ],
        },
        {
            name: 'Aryanshi Rana',
            role: 'Creative and Graphic Design Head',
            image: img10,
            linkedin: 'https://www.linkedin.com/in/aryanshi-rana-637a84287?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            desc: [
                'A Food, Nutrition and Dietetics major with a passion for art. I find joy in every brushstroke and believe that art has the power to inspire people.',
                "I'm the Creative Head for the Ozone Student Society and aspire to connect with like-minded peers, access valuable resources, and contribute to our community.",
                'Acknowledging the subtle victories in college competitions that have shaped my academic path. Each recognition is a gentle reminder of the importance of perseverance and collaboration. Looking forward to the next chapter of learning.',
                "Get ready for a dose of intellectual adrenaline! Our Ozone Student Society is where serious study meets unserious fun. From brainy discussions to heart-pounding events, we're injecting fun into learning. Join us and unleash your inner science superhero with us!"
            ],

        }, {
            name: 'Abhinav Kaintura',
            role: 'Social media and Graphic Head',
            image: img11,
            linkedin: 'https://www.linkedin.com/in/abhinav-kaintura-59548a256/',
            desc: [
                'I am willing to assist you in every way within my capabilities and control, provided there is dedication on your part.',
                "Despite appearing lazy, I am simply challenged in motivation, which won't hinder my ability to support and help you.",
                'Your commitment is crucial, as I am prepared to extend my assistance with dedication and determination.',
                'First formed society of school of health and science technology with up holds every event related to our stream.'
            ],

        }, {
            name: 'Rohan Patteti',
            role: 'Editorial Lead',
            image: img12,
            linkedin: 'https://www.linkedin.com/in/rohan-sathwik-patteti-03185a227?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            desc: [
                'I lead the Editorial team for Ozone Student Society, overseeing our communication initiatives.',
                'Described as optimistic, passionate and friendly I build a  collaborative and supportive environment around me to deliver high-quality and engaging content.',
                'I embody a blend of borderline humor, creativity, and a critical mindset, enhancing my leadership capabilities and infusing innovation into my work.',
                "Ozone is the first student society initiated by the very own students of School of Health Sciences and Technology which then concocted with students from different background and specialisation to justify as society. By the name itself symbolizes preserving and protecting as the layer Ozone, Ozone centres on individual and individual's contribution to the environment."
            ],

        },
        {
            name: 'Utkarsh Sharma',
            role: 'Photography Lead',
            image: img13,
            linkedin: '',
            desc: [
                'A regular student at UPES, I bring skills in photography to the academic landscape.',
                'Possessing qualities of leadership, I aim to contribute positively to the university community.',
                'Good communication skills complement my abilities, enhancing my interactions',
                'Ozone student society is formed by the students of health science to promote the importance of education in health sector'
            ],

        }, {
            name: 'Ashma',
            role: 'CSR Lead',
            image: img14,
            linkedin: 'https://www.linkedin.com/in/ashi-bisht-a30884277/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
            desc: [
                'Currently pursuing microbiology, I am driven by the belief that a life lived for others is genuinely meaningful.',
                'Engaged in social work and serving as the CSR lead, I embody a down-to-earth approach, fostering connections and making a positive impact.',
                'Eager to learn and aspiring to be a compassionate and effective leader, I am committed to continuous personal and professional growth.',
                'Ozone, a dedicated student society, focuses on advancing societal well-being through strategic programs. Serving as a platform for young minds, we prioritize health, nurturing a community for collective prosperity.'
            ],

        }, {
            name: 'Vidhi Thapa',
            role: 'PR And Sponsorship Lead',
            image: img15,
            linkedin: 'https://www.linkedin.com/in/vidhi-thapa-80771b218?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            desc: [
                'I am known for my patience, coupled with effective communication skills that enable me to connect and interact with others in a meaningful way.',
                'A diligent and hardworking individual, I consistently uphold a strong sense of duty, ensuring that I fulfill my responsibilities with dedication and precision.',
                'Embracing an open-minded approach, I actively welcome diverse ideas and perspectives, complemented by my adept coordination skills',
                "Ozone is here to make a difference, leaving it's mark in the college, by being the most efficient, fastest growing and prominent student society."
            ],
        }, {
            name: 'Madhav Nair',
            role: 'Event Management Lead',
            image: img16,
            linkedin: 'https://www.linkedin.com/in/madhav-nair-7005aa239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            desc: [
                'Currently studying for an Integrated BSc in Microbiology, exploring microorganisms and their applications across various fields.',
                'Observant and hardworking, consistently demonstrating a keen eye for detail and a strong work ethic.',
                "Since 2022, an active member of the Sphurit Sports Committee at UPES, contributing skills and dedication to the committee's activities and initiatives.",
                'OZONE student society is the first student society of School of Health Sciences and Technology primarily focused to conduct various health awareness activities throughout the campus.'
            ],

        }, {
            name: 'Shrejal Kirsali ',
            role: 'Creative And Graphic Design Lead',
            image: img17,
            linkedin: 'https://www.linkedin.com/in/shrejal-kirsali-b3168b252?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            desc: [
                'Creative, hard-working, and detail-oriented, I bring a dynamic approach to my work.',
                'Analytical, helpful, and a little responsible, I thrive in problem-solving and assisting others.',
                'My strengths lie in a balance of creativity, diligence, and a thoughtful, analytical mindset',
                'Ozone helps in Exploring scientific concepts through hands-on activities, Raises awareness about environmental issues,Fosters creativity and artistic expression. :)'
            ],

        }, {
            name: 'Akshit Upadhyay',
            role: 'Social Media and Graphics Lead',
            image: img19,
            linkedin: 'https://www.linkedin.com/in/akshit-upadhyay-26009a245?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            desc: [
                "I am interested in sports, music and theatre. I'm a part of the Aks and Saptak, the UPES  Music and Dramatics Club.",
                'I do video editing and social media management as a side work.',
                'My achievements in college include a podium finish at THOMSO, IIT Roorkee national level theatre competition and the first price in Pehchaan 3.0 Battle of Bands. ',
                'Ozone student society is a place where we work collaboratively on the aspects of the School of Health Sciences and Technology. The events in Ozone range from culture to health and welfare... Sky(Ozone) is the limit'
            ],

        },
    ];

    return (
        <div>
            <TeamSection teamMembers={teamMembers} faculty={faculty} />
        </div>
    );
};

export default App;
